import { Component, OnInit, Input } from '@angular/core';
import { StaticValueService } from 'src/app/services/http/business/staticValue/static-value.service';
import { IStaticValue } from 'src/app/interfaces/static-value';
import { SnackBarService } from 'src/app/services/common/snackBar.service';
import { TranslateService } from '@ngstack/translate';
import { SoundEnum } from 'src/app/enums/sound.enum';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-sexuality',
  templateUrl: './sexuality.component.html',
  styleUrls: ['./sexuality.component.css']
})
export class SexualityComponent implements OnInit {

  // sexualityForm: FormGroup;
  @Input() selected: number;
  @Input() form: FormGroup;

  dataSource: [IStaticValue]

  constructor(
    private staticValueService: StaticValueService,
    private snackBar: SnackBarService,
    public translate: TranslateService) { }

  ngOnInit() {
    // this.sexualityForm = this.fb.group({
    //   'Sexuality': [this.selected ? this.selected : null, Validators.required]
    // })
    this.genderTypes(false);
  }

  genderTypes(value: boolean) {
    this.staticValueService.genderType(value).subscribe(res => {
      this.dataSource = res;
    }, () => {
      this.snackBar.OpenSnackBar(this.translate.get('error.received', { name: this.translate.get('label.sexuality') }), 'OK', 5000, SoundEnum.beep);
    })
  }


}
